module.exports = __webpack_public_path__ + "73e5359074d76bcedc07d80f3bbe1c35.svg";